import { SelectionModel } from '@angular/cdk/collections';
import { EventEmitter } from '@angular/core';
import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { NotifificationE } from '../../../Enum/notifications.enum';
import { ToolsHelper } from '../../../helpers/tools';
import { TxtConv } from '../../../helpers/txt-conv';
import { UserI } from '../../../interfaces/users/user.interface';
import { UserFormComponent } from '../../../modules/users-management/forms/user-form/user-form.component';
import { CommonService } from '../../../services/common.service';
import { GroupsService } from '../../../services/groups.service';
import { MessageService } from '../../../services/message.service';
import { NotificationsService } from '../../../services/notifications.service';
import { UsersService } from '../../../services/users.service';
import { UserBodyModalComponent } from '../../modals/user-body-modal/user-body-modal.component';
import { UserFoodsModalComponent } from '../../modals/user-foods-modal/user-foods-modal.component';
import { UserNotificationsModalComponent } from '../../modals/user-notifications-modal/user-notifications-modal.component';
import { UserProfileComponent } from '../../modals/user-profile/user-profile.component';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit, OnChanges {

  // region Atributos
  public spinner = false;
  public btnSpinner = false;
  public currentIdContract: string;
  listUsers: MatTableDataSource<any>;
  listOfColumns: string[] = ['select', 'id', 'name', 'lastname', 'email', 'telephone', 'active', 'actions'];
  displayedColumns = this.listOfColumns;
  columns = this.listOfColumns;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  searchKey: string;
  public editUser: UserI;

  @Input() public currentModule: string;
  @Input() externalAction: string;
  @Input() reload: boolean;

  @Input() idgroup: number;
  @Input() tableTitle: string;
  @Input() users: UserI[] = [];


  @Output() emitSelectedUsr = new EventEmitter();

  selection = new SelectionModel<UserI>(true, []);


  // endregion

  // region Constructor
  constructor(
    private userService: UsersService,
    private dialog: MatDialog,
    private messageService: MessageService,
    private activateRoute: ActivatedRoute,
    public commonService: CommonService,
    public notificationServ: NotificationsService,
    public groupServ: GroupsService
  ) {
    if (this.activateRoute.snapshot.data) {
      if (this.activateRoute.snapshot.data.module) {
        this.currentModule = this.activateRoute.snapshot.data.module;
        console.log(this.currentModule);
      }
    } else {
      this.currentModule = 'users';
    }
  }

  // endregion

  // region Métodos
  ngOnInit() {
    console.log('onInit current module', this.currentModule);
    console.log('onInit idgroup', this.idgroup);
    //this.getUserList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    let groupChange = changes.idgroup;
    let reloadChange = changes.reload;
    if (groupChange && (groupChange.firstChange === false || groupChange.isFirstChange() === true)) {
      if (this.idgroup) {
        this.getUserList();
        console.log('call from idgroup change', this.currentModule);
      }
    }

    if (reloadChange && (reloadChange.firstChange === true || reloadChange.isFirstChange() === false)) {
      if (this.reload == true) {
        this.getUserList();
      }
    }



    if (this.externalAction && this.users) {
      this.getUserList();
    }

  }

  // Función para manejar que columnas se muestran
  checkDisplayColumns() {
    this.displayedColumns = this.columns;
  }

  transFormText(data) {
    return TxtConv.txtTransform(data);
  }

  // Función para obtener el listado de contratos
  getUserList() {
    this.spinner = true;
    this.listUsers = null;

    switch (this.currentModule) {
      case 'users':
        this.userService.getList('active').subscribe(response => {
          if (response.ok === true) {
            this.users = [... response.users];

            this.users.forEach(element => {
              element.active = true;
            });
            this.loadMatTable(this.users);
          }
          this.spinner = false;
        }, error => {
          this.spinner = false;
          console.log(error);
        }).add(() => {
          this.userService.getList('inactive').subscribe(res => {
            if (res.ok === true) {
              let inactiveUsr: UserI[] = res.users;
              inactiveUsr.forEach(element => {
                element.active = false;
                this.users.push(element);
              });
              this.loadMatTable(this.users);
              console.log(this.users);
            }
          })
        });
        break;
      case 'groups':
          this.listOfColumns = ['select', 'name', 'lastname', 'telephone', 'actions'];
          this.displayedColumns = this.listOfColumns;
          this.columns = this.listOfColumns;
          console.log('module', this.currentModule);
          console.log('listOfColumns', this.listOfColumns);
          if (this.externalAction && this.externalAction === 'add-user-group') {
            setTimeout(() => {
              this.spinner = false;
              this.loadMatTable(this.users);
            }, 2000);
          } else {
            this.userService.getListByGroup(this.idgroup).subscribe(res => {
              if (res.ok === true) {
                this.users = [... res.users];
                this.loadMatTable(this.users);
              }
              this.spinner = false;
            }, error => {
              console.log(error);
              this.spinner = false;
            })
          }

        break;
    }
  }

  loadMatTable(data: UserI[]) {
    this.listUsers = new MatTableDataSource(data);

    this.listUsers.sort = this.sort;
    this.listUsers.paginator = this.paginator;
  }

  // Función para borrar el filtro de busqueda
  onSearchClear() {
    this.searchKey = '';
    this.applyFilter();
  }

  // Función para aplicar el filtro de busqueda
  applyFilter() {
    this.listUsers.filter = this.searchKey.trim().toLocaleLowerCase();
  }

   /** Whether the number of selected elements matches the total number of rows. */
   isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.listUsers.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.listUsers.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: UserI): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    //return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  async sendNotiToUsers() {
    let selectedUsr: UserI[] = this.selection.selected;

    let diffSelectdUsr = ToolsHelper.diffObjValues(selectedUsr, 'id');

    if (!diffSelectdUsr) {
      this.messageService.printStatus('Debes seleccionar al menos 1 participante para enviar notificaciones', 'warning');
      return;
    }

    const {value: notificacion} = await this.messageService.confirmNotification();

    if (notificacion && notificacion.length > 0) {

      let _notifications = [];

      for (let i = 0; i < diffSelectdUsr.length; i++) {
        _notifications.push({
          user_id: diffSelectdUsr[i]['id'],
          message: notificacion[1].message,
          type: notificacion[0].message
        });
      }
      let data = {
        notifications: _notifications
      }

      this.notificationServ.sendNotifications(data).subscribe(res => {
        if (res.ok === true) {
          this.messageService.printStatus(res.message, 'success');
          this.selection.clear();
        }
      }, error => {
        this.messageService.printStatusArray(error.error.errors, 'error');
        console.log(error);
      });
    }
  }

  addUser() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '80%';
    dialogConfig.data = {
      user: {
        id: 0
      }
    };
    const dialogRef = this.dialog.open(UserFormComponent, dialogConfig);

    dialogRef.componentInstance.userSubmit.subscribe((data) => {
      if (data === true) {
        this.getUserList();
      }
    });
    dialogRef.componentInstance.closeModal.subscribe(() => {
      dialogRef.close();
    });
  }

  rmFromGroup(user: UserI) {
    if (this.idgroup) {
      this.messageService.confirmRequest('¿Estás seguro de querer expulsar a: ' + user.name + 'del grupo?').then((data) => {
        if (data.value) {
          let data = {
            group_id: this.idgroup,
            user_id: user.id
          }
          this.groupServ.unlinkUserFromGroup(data).subscribe(res => {
            if (res.ok === true) {
              this.messageService.printStatus(res.message, 'success');
              this.getUserList();
            }
          }, error => {
            console.log(error);
            this.messageService.printStatusArray(error.error.errors, 'error');
          });
        }
      })
    }
  }

  showUsrFoods(user: UserI) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '80%';
    dialogConfig.panelClass = 'food-modal';
    //dialogConfig.height = '100%';

    const dialogRef = this.dialog.open(UserFoodsModalComponent, dialogConfig);
    dialogRef.componentInstance.user = user;
    dialogRef.componentInstance.needSelfLoadFoods = true;
    dialogRef.componentInstance.qualificationSubmit.subscribe((data) => {
      if (data === true) {
        //this.getUserList();
      }
    });
    dialogRef.componentInstance.closeModal.subscribe(() => {
      dialogRef.close();
    });
  }

  showUsrBodies(user: UserI) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '80%';
    //dialogConfig.height = '100%';

    const dialogRef = this.dialog.open(UserBodyModalComponent, dialogConfig);
    dialogRef.componentInstance.user = user;
    dialogRef.componentInstance.needSelfLoadBodies = true;
    dialogRef.componentInstance.qualificationSubmit.subscribe((data) => {
      if (data === true) {
        //this.getUserList();
      }
    });
    dialogRef.componentInstance.closeModal.subscribe(() => {
      dialogRef.close();
    });
  }

  showUsrNotifications(user: UserI) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '80%';

    const dialogRef = this.dialog.open(UserNotificationsModalComponent, dialogConfig);
    dialogRef.componentInstance.user = user;
    dialogRef.componentInstance.notificationSubmit.subscribe((data) => {
      if (data === true) {
        //this.getUserList();
      }
    });
    dialogRef.componentInstance.closeModal.subscribe(() => {
      dialogRef.close();
    });
  }

  showUsrProfile(element: UserI) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "80%";

    const dialogRef = this.dialog.open(
      UserProfileComponent,
      dialogConfig
    );
    dialogRef.componentInstance.userId = element.id;
    dialogRef.componentInstance.closeModal.subscribe(() => {
      dialogRef.close();
    });
  }

  showButton(action: string): boolean {
    switch (action) {
      case 'add-user-group':
        if (this.currentModule === 'groups' && (this.externalAction && this.externalAction === 'add-user-group')) {
          return true;
        }
        return false;
      case 'remove-user-group':
        if (this.currentModule === 'groups' && (!this.externalAction)) {
          return true;
        }
        return false;
      case 'user-notifications':
        return true;
      case 'food-qualification':
        if (this.currentModule === 'groups' && (!this.externalAction)) {
          return true;
        }
      case 'body-qualification':
        if (this.currentModule === 'groups' && (!this.externalAction)) {
          return true;
        }
    }
    return false;
  }

  emitSelectedUser(user: UserI) {
    this.messageService.confirmRequest(`¿Estás seguro de querer agregar a: ${user.name} al grupo?`).then((data) => {
      if (data.value) {
        this.emitSelectedUsr.emit(user);
      }
    });
  }

  // Función para editar datos del usuario
  onEdit(_user) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '80%';
    dialogConfig.data = {
     user: _user
    };
    const dialogRef = this.dialog.open(UserFormComponent, dialogConfig);
    dialogRef.componentInstance.userSubmit.subscribe((data) => {
      if (data === true) {
        this.getUserList();
      }
    });
    dialogRef.componentInstance.closeModal.subscribe(() => {
      dialogRef.close();
    });
  }

  // Funcion para elimianr un usuario
  delete(_userid) {
    this.messageService.confirmRequest('Do you want to delete this user, this action can\'t be undone ?')
      .then((res) => {
        if (res.value) {
          const data = {
            iduser: _userid
          };
          this.userService.delete(_userid).subscribe(res => {
            if (res.ok === true) {
              this.messageService.printStatus(res.message, 'success');
              this.getUserList();
            }
          }, error => {
            console.log(error);
            this.messageService.printStatus(error.error.errors, 'error');
          });
        } else {
          this.messageService.dismissAction();
        }
      });
  }
  // endregion

}
